import { jsx as _jsx } from "react/jsx-runtime";
import { InputField } from '@rocketlane/ui';
import useFormInstance from 'antd/lib/form/hooks/useFormInstance';
import React, { useCallback } from 'react';
import styled from 'styled-components';
import { Input as AntdInput } from 'components/atoms/input';
import { useAntdRlUISwitcher } from 'contexts/antd-rlui-switcher';
function mapAntdPropsToRadixProps(props) {
    const { size, bordered: _bordered, prefix, suffix, ...restProps } = props;
    // Map Antd size values to Radix size values
    let mappedSize;
    if (size === 'small') {
        mappedSize = 'small';
    } else if (size === 'large') {
        mappedSize = 'large';
    } else if (size === 'middle') {
        mappedSize = 'medium';
    } else if (size === 'default') {
        mappedSize = 'medium';
    } else {
        mappedSize = 'medium'; // default fallback
    }
    const startAddons = prefix ? [
        prefix
    ] : undefined;
    const endAddons = suffix ? [
        suffix
    ] : undefined;
    return {
        ...restProps,
        size: mappedSize,
        startAddons,
        endAddons
    };
}
const useFormAwareSizeProps = (props)=>{
    const form = useFormInstance();
    const insideForm = !!form;
    const { size, ...restProps } = props;
    const isSizeUndefined = !size;
    const updatedSize = insideForm && isSizeUndefined ? 'large' : size;
    return {
        ...restProps,
        size: updatedSize
    };
};
const RocketlaneInput = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const updatedProps = useFormAwareSizeProps(props);
    return /*#__PURE__*/ _jsx(InputField, {
        ...updatedProps,
        ref: ref
    });
});
const InputComponent = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const isNewDesignEnabled = useAntdRlUISwitcher();
    // Create ref callback outside conditional to satisfy React hooks rules
    const radixRef = useCallback((element)=>{
        if (!ref) {
            return;
        }
        const refElement = element;
        if (typeof ref === 'function') {
            ref(refElement);
        } else {
            ref.current = refElement;
        }
    }, [
        ref
    ]);
    if (isNewDesignEnabled) {
        const radixProps = mapAntdPropsToRadixProps(props);
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ _jsx(RocketlaneInput, {
            ...radixProps,
            ref: radixRef
        });
    }
    // Convert "default" size to "middle" for AntdInput
    const antdProps = {
        ...props,
        size: props.size === 'default' ? 'middle' : props.size
    };
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ _jsx(AntdInput, {
        ...antdProps,
        ref: ref
    });
});
InputComponent.displayName = 'InputComponent';
// Create the facade Input as a styled component to enable ${Input} interpolation
// This extends the original AntdInput which already works with styled-components
export const Input = styled(InputComponent)``;
// Add static properties to match AntdInput interface
Input.Group = AntdInput.Group;
Input.Search = AntdInput.Search;
Input.TextArea = AntdInput.TextArea;
Input.Password = AntdInput.Password;
Input.displayName = 'Input';
export { TextArea } from 'components/facade/textarea';
export { InputNumber, SearchInput } from 'components/atoms/input';
